import React, { useState, useRef, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import DongTienApi from "service/BaoCao/DongTienApi";
import InDsChiTietDongTien from "./InDsChiTietDongTien";
import { formatDayMonth } from "utils/formatDate";
import { pushNotification } from "utils/notifications";

const BtnInChiTiet = ({ category, flow, dateFrom, dateTo, title, config }) => {
    const componentToPrintRef = useRef();
    const [isFetching, setIsFetching] = useState(false);
    const [printData, setPrintData] = useState(null);
    const handlePrint = useReactToPrint({
        content: () => componentToPrintRef.current,
        onAfterPrint: () => setPrintData(null),
    });

    useEffect(() => {
        if (printData) {
            handlePrint();
        }
    }, [printData]);

    const handleFetchAndPrint = () => {
        if (isFetching) return;
        setIsFetching(true);
        const sFrom = dateFrom ? formatDayMonth(dateFrom) : "";
        const sTo = dateTo ? formatDayMonth(dateTo) : "";
        DongTienApi.getChiTiet(category, flow, sFrom, sTo, -1, 0)
            .then(res => {
                if (res.status === 200 && res.data && res.data.List.length > 0) {
                    setPrintData(res.data);
                } else {
                    pushNotification("Không có dữ liệu để in!", "info", "TOP_CENTER", 2000);
                }
            })
            .catch(error => {
                console.error("Lỗi in:", error);
                pushNotification("Lỗi khi tải dữ liệu in!", "error");
            })
            .finally(() => {
                setIsFetching(false);
            });
    };

    return (
        <>
            <button
                type="button"
                className="btn ml-2"
                onClick={handleFetchAndPrint}
                disabled={isFetching}
                style={{height: 40, backgroundColor: "#006266", color: "white", fontSize: 15, textTransform: "none"}}
            >
                {isFetching ? (
                    <><span className="spinner-border spinner-border-sm"></span> Đang tải...</>
                ) : (
                    <><i className="fas fa-print"></i> In danh sách</>
                )}
            </button>
            <div style={{ display: "none" }}>
                {printData && (
                    <InDsChiTietDongTien
                        ref={componentToPrintRef}
                        listData={printData.List}
                        totals={{
                            TotalSoTien: printData.TotalSoTien,
                            TotalPhiHoaHong: printData.TotalPhiHoaHong,
                            TotalRecords: printData.TotalRecords,
                        }}
                        title={title}
                        config={config}
                        category={category}
                        flow={flow} 
                    />
                )}
            </div>
        </>
    );
};

export default BtnInChiTiet;